
export class UUIDUtils {
    /**
     * Expression régulière pour la validation d'UUID v4
     */
    private static UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    /**
     * Vérifie si une chaîne est un UUID v4 valide
     * 
     * @param value La chaîne à vérifier
     * @returns boolean Vrai si la chaîne est un UUID valide
     */
    public static isValid(value: string): boolean {
        if (!value) return false;
        return UUIDUtils.UUID_REGEX.test(value);
    }

    /**
     * Génère un nouvel UUID v4
     * Note: Cette implémentation est similaire à celle vue dans le code fourni
     * 
     * @returns string Un nouvel UUID v4
     */
    public static generate(): string {
        let d = new Date().getTime();
        
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now();
        }
        
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    }
}
